import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './components/home/home.component';
import { AgenciesComponent } from './components/agencies/agencies.component';
import { AgencyComponent } from './components/agency/agency.component';
import { ContactComponent } from './components/contact/contact.component';
import { NotFoundComponent } from './components/not-found/not-found.component';

const routes: Routes = [
    {
        path: 'agencies',
        component: AgenciesComponent
    },
    {
        path: 'agency/:parent_agency_id',
        component: AgencyComponent
    },
    {
        path: 'contact',
        component: ContactComponent
    },                 
    {
        path: '',
        component: HomeComponent
    },
    {
        path: '**',
        component: NotFoundComponent
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})

export class AppRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts